import {
  ShopOutlined,
  FunnelPlotOutlined,
  TeamOutlined,
  RocketOutlined,
  FileSearchOutlined,
  ScheduleOutlined,
  BarChartOutlined,
} from '@ant-design/icons';
import type { SidebarConfig } from './types';

export const marketingSidebar: SidebarConfig = {
  module: 'marketing',
  titleKey: 'common:nav.marketing',
  icon: <ShopOutlined />,
  sections: [
    {
      key: 'pipeline',
      labelKey: 'marketing:sidebar.sections.pipeline',
      items: [
        { key: 'leads', path: '/marketing/leads', labelKey: 'marketing:pages.leads', icon: <FunnelPlotOutlined /> },
        { key: 'opportunities', path: '/marketing/opportunities', labelKey: 'marketing:pages.opportunities', icon: <RocketOutlined /> },
        { key: 'tenders', path: '/marketing/tenders', labelKey: 'marketing:pages.tenders', icon: <FileSearchOutlined /> },
      ],
    },
    {
      key: 'directory',
      labelKey: 'marketing:sidebar.sections.directory',
      items: [
        { key: 'clients', path: '/marketing/clients', labelKey: 'marketing:pages.clients', icon: <TeamOutlined /> },
        { key: 'activities', path: '/marketing/activities', labelKey: 'marketing:pages.activities', icon: <ScheduleOutlined /> },
      ],
    },
    {
      key: 'analytics',
      labelKey: 'marketing:sidebar.sections.analytics',
      items: [
        { key: 'reports', path: '/marketing/reports', labelKey: 'marketing:pages.reports', icon: <BarChartOutlined /> },
      ],
    },
  ],
};
